import axios from "axios";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import ListViewGeneric from "./ListViewGeneric";

function GenericListView({ label, table, link, noNew, getColumns, where }) {
  const [listData, setListData] = useState([]);
  const location = useLocation();

  useEffect(() => {
    axios
      .get("/get.php?name=" + table + (where ?? ""))
      .then((res) => {
        setListData(res.data);
      })
      .catch((err) => console.log(err));
  }, [table, location.key]);

  return (
    <ListViewGeneric
      title={label}
      data={listData}
      noNew={noNew}
      link={link}
      columns={getColumns(link)}
    />
  );
}

export default GenericListView;
